<template>
    <div class="relative">
        <PremiumViewProfile :user-data="userData" :dialog="viewProfile" @update-dialog='closeDialog' />
        <LoadingSpinner v-if="getLoading" class="h-[calc(100vh-190px)] w-full" />
        <div v-else
            class="grid xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-4 sm:grid-cols-3 xl:gap-5 sm:gap-3 gap-3 xs:grid-cols-3 xxs:grid-cols-2 justify-items-center  pt-3 pb-10 sm:h-[calc(100vh-150px)] h-[calc(100vh-250px)]  overflow-y-auto scrollbar-hide">
            <UserCard :user-detail="user" v-for="(user, idx) in getUserListStatus" :key="user.name" v-motion
                :initial="{ opacity: 0, y: 100 }" :enter="{
                    opacity: 1, y: 0, transition: {
                        duration: 400,
                        type: 'keyframes',
                        ease: 'backInOut',
                        delay: `${idx}00`
                    },
                }" @showProfile="displayUser" />
        </div>
    </div>
</template>
<script>
import LoadingSpinner from '@/pages/front/straight/childs/LoadingSpinner.vue';
import axios from 'axios';
import UserCard from './UserCard.vue';
import PremiumViewProfile from '@/pages/front/straight/childs/PremiumViewProfile.vue';
import { CometChat } from "@cometchat-pro/chat";


export default {
    components: { UserCard, LoadingSpinner, PremiumViewProfile },
    data() {
        return {
            users: [],
            viewProfile: false,
            userData: {},
            filters: {
                interestType: this.$store.getters.StateUser.data.account_type,
                hobbies : '',
                ageFrom : '',
                ageTo : '',
            }
        }
    },
    computed: {
        getLoading() {
            return this.$store.getters.isLoading;
        },
        // getAccountType() {
        //     const accountType = this.$store.getters.getPremiumSearchFilters?.interestType
        //     if (accountType) {
        //         this.filters.interestType = accountType
        //     }
        // },
        // getHobbies() {
        //     if (this.$store.getters.getPremiumSearchFilters?.hobbies) {
        //         this.filters.hobbies = this.$store.getters.getPremiumSearchFilters?.hobbies
        //     }else{
        //         this.filters.hobbies = ''
        //     }
        // },
        // getAgeRange() {
        //     if (this.$store.getters.getPremiumSearchFilters?.ageFrom) {
        //         this.filters.ageFrom = this.$store.getters.getPremiumSearchFilters?.ageFrom
        //         this.filters.ageTo = this.$store.getters.getPremiumSearchFilters?.ageTo
        //     }
        // },
        getUserListStatus() {
            if (this.$store.getters.isStatus) {
                return this.users.filter(user => user.status == 'online')
            } else {
                return this.users
            }

        },

    },
    methods: {
        closeDialog(val) {
            this.viewProfile = val;
        },
        displayUser(userData) {
            this.userData = userData
            // console.log(userData ,  'get from userCard')
            this.viewProfile = true

        },
        async getAllProfiies() {
            try {
                this.$store.dispatch('setloading', true)
                console.log(this.filters) 
                const resp = await axios.get(`all-profiles?account_type=${this.filters.interestType}&search=${this.filters.hobbies}&age_from=${this.filters.ageFrom}&age_to=${this.filters.ageTo}`);
                const intialUser = resp.data.data.data;
                intialUser.map(singleUser => {
                    let UID = singleUser.uuid;
                    CometChat.getUser(UID).then(
                        user => {
                            if (user.uid === singleUser.uuid) {
                                singleUser.status = user.status;
                            }
                        }, error => {
                            console.log("User details fetching failed with error:", error);
                        }
                    );
                });
                this.users = intialUser;
            } catch (error) {
                console.log(error)
            }
            finally {
                this.$store.dispatch('setloading', false)
            }
        }
    },
    mounted() {
        this.getAllProfiies();
    },
    created() {
        this.$store.dispatch('getInterests');
        var listenerID = "UNIQUE_LISTENER_ID";
        CometChat.addUserListener(
            listenerID,
            new CometChat.UserListener({
                onUserOnline: onlineUser => {
                    this.users.forEach(user => {
                        if (user.uuid === onlineUser.uid) {
                            user.status = onlineUser.status;
                        }
                    });
                    /* when someuser/friend comes online, user will be received here */

                    console.log("On User Online:yes", { onlineUser });
                },
                onUserOffline: offlineUser => {
                    /* when someuser/friend went offline, user will be received here */
                    this.users.forEach(user => {
                        if (user.uuid === offlineUser.uid) {
                            user.status = offlineUser.status;
                        }
                    });
                    console.log("On User Offline:", { offlineUser });
                }
            })
        );
        this.$store.subscribe( (mutations , state)  =>  {
            if(mutations.type == 'setPremiumSearchFilters'){
                this.filters = mutations.payload;
                if(this.filters.hobbies == null){
                    this.filters.hobbies = ''
                }
            }
        })

    },
    watch: {
        filters:{
            handler(){
                this.getAllProfiies();
            },
            deep : true
        }
    }

}
</script>
<style scoped>
.scrollbar-hide::-webkit-scrollbar {
    display: none !important;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}
</style>